import cn from 'classnames'
import React from 'react'

interface Props {
  label?: string
  className?: string
  variant?: 'primary' | 'secondary' | 'yellow' | 'enhanced' | 'SolutionCarousel' | 'company'
}

export const PremiumTag: React.FC<Props> = ({ className, label = 'Premium', variant = 'primary' }) => {
  if (variant === 'primary') {
    return (
      <p
        className={cn(
          'bg-lightRoyalBlue text-white uppercase font-secondary font-bold px-[6px] py-[2px] text-[12px] rounded tracking-widest',
          className,
        )}
      >
        {label}
      </p>
    )
  }
  if (variant === 'secondary') {
    return (
      <p className={cn('bg-lightRoyalBlue text-white font-primary px-[2px] py-[2px] text-[12px] rounded', className)}>
        {label}
      </p>
    )
  }
  if (variant === 'enhanced') {
    return (
      <span
        className={cn(
          'inline-flex h-5 items-center rounded border border-amber-200/80 bg-[#FFF8E6] px-1.5 mr-[10px] text-[12px] font-secondary font-bold leading-5 tracking-[0.5px] text-textdark',
          className,
        )}
      >
        Enhanced
      </span>
    )
  }
  if (variant === 'yellow') {
    return (
      <span className="inline-block mr-[10px] bg-sand text-textdark text-[12px] font-secondary font-bold h-5 w-[77px] text-center leading-5 tracking-[0.5px] rounded">
        {label}
      </span>
    )
  }
  if (variant === 'SolutionCarousel') {
    return (
      <span className="inline-block bg-sand text-textdark text-[12px] font-secondary font-bold h-5 w-[77px] text-center leading-5 tracking-[0.5px] rounded">
        {label}
      </span>
    )
  }
  if (variant === 'company') {
    return (
      <span
        className={cn(
          'bg-[#5a5555fa] inline-block mr-[10px] text-white text-[12px] font-secondary font-bold h-5 w-auto px-[8px] text-center leading-5 tracking-[0.5px] rounded',
          className,
        )}
      >
        Company Page
      </span>
    )
  }
  return null
}
